import { render, staticRenderFns } from "./CommonEmpty.vue?vue&type=template&id=5502641c&scoped=true&"
import script from "./CommonEmpty.vue?vue&type=script&lang=js&"
export * from "./CommonEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5502641c",
  null
  
)

export default component.exports